import React, { useEffect } from 'react';
import { Mail, Phone, Globe, MapPin, Building, FileText } from 'lucide-react';
import SharedNavigation from './SharedNavigation';
import './SharedStyles.css';

const Imprint: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="app-page">
      <SharedNavigation />

      <main className="app-main">
        <div className="app-container-narrow">
          <div className="text-center mb-6">
            <h1 className="app-title">Impressum</h1>
            <p className="app-subtitle">
              Rechtliche Angaben gemäß § 5 TMG
            </p>
          </div>

          {/* Quick Contact */}
          <div className="app-content" style={{ marginBottom: '2rem' }}>
            <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Building size={24} style={{ color: 'var(--voidmind-primary)' }} />
              Kontakt & Ansprechpartner
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem', marginTop: '1.5rem' }}>
              <div style={{ padding: '1.5rem', background: 'var(--background-light)', borderRadius: '8px', border: '1px solid var(--border-light)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                  <Mail size={20} style={{ color: 'var(--voidmind-primary)' }} />
                  <strong>E-Mail</strong>
                </div>
                <p style={{ margin: 0, fontSize: '0.9rem' }}>
                  <a href="mailto:info@voidmind.io">info@voidmind.io</a>
                </p>
              </div>
              <div style={{ padding: '1.5rem', background: 'var(--background-light)', borderRadius: '8px', border: '1px solid var(--border-light)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                  <Phone size={20} style={{ color: 'var(--voidmind-primary)' }} />
                  <strong>Telefon</strong>
                </div>
                <p style={{ margin: 0, fontSize: '0.9rem' }}>+49 (0) 15678 589503</p>
              </div>
              <div style={{ padding: '1.5rem', background: 'var(--background-light)', borderRadius: '8px', border: '1px solid var(--border-light)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                  <MapPin size={20} style={{ color: 'var(--voidmind-primary)' }} />
                  <strong>Adresse</strong>
                </div>
                <p style={{ margin: 0, fontSize: '0.9rem' }}>
                  Holzwasen 11<br />
                  73087 Bad Boll
                </p>
              </div>
            </div>
          </div>
          
          <div className="app-content">
            <section>
              <h2>Angaben gemäß § 5 TMG</h2>
              <div style={{ marginTop: '1rem' }}>
                <p><strong>VoidMind</strong></p>
                <p>Christian Romeni<br />
                  Holzwasen 11<br />
                  73087 Bad Boll<br />
                  Deutschland</p>
              </div>
            </section>

            <section>
              <h2>Kontakt</h2>
              <div style={{ display: 'grid', gap: '1rem', marginTop: '1rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    background: 'var(--primary-medium)', 
                    borderRadius: '6px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    color: 'white'
                  }}>
                    <Mail size={20} />
                  </div>
                  <div>
                    <strong>E-Mail:</strong>{' '}
                    <a href="mailto:info@voidmind.io">info@voidmind.io</a>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    background: 'var(--primary-medium)', 
                    borderRadius: '6px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    color: 'white'
                  }}>
                    <Phone size={20} />
                  </div>
                  <div>
                    <strong>Telefon:</strong>{' '}
                    <span>+49 (0) 15678 589503</span>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <div style={{ 
                    width: '40px', 
                    height: '40px', 
                    background: 'var(--primary-medium)', 
                    borderRadius: '6px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    color: 'white'
                  }}>
                    <Globe size={20} />
                  </div>
                  <div>
                    <strong>Website:</strong>{' '}
                    <span>pfaendungstabelle.voidmind.io</span>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2>Steuernummer</h2>
              <p>
                Steuernummer:
                <br />
                <strong>9708604587</strong>
              </p>
            </section>

            <section>
              <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <div style={{ marginTop: '1rem' }}>
                <p><strong>Christian Romeni</strong><br />
                  Inhaber<br />
                  Holzwasen 11<br />
                  73087 Bad Boll</p>
              </div>
            </section>

            <section>
              <h2>EU-Streitschlichtung</h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p>
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section>
              <h2>Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2>Haftung für Inhalte</h2>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen 
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind 
                wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder 
                gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, 
                die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
            </section>

            <section>
              <h2>Haftung für Links</h2>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir 
                keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine 
                Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
                Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </section>

            <section>
              <h2>Urheberrecht</h2>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, 
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Imprint;
